import styled from 'styled-components';
import { spacingMixin } from '../../mixins/spacingMixin';
import CustomPropTypes from '../../util/custom-prop-types';

/**
 * Generic component for applying spacing props around its children.
 *
 * All spacing props support inline media query objects.
 *
 * @since 5.0.0
 */
var Spacer = /*#__PURE__*/styled.div.withConfig({
  displayName: "Spacer",
  componentId: "c11n-8-107-0__sc-17suqs2-0"
})(["", ""], spacingMixin);
Spacer.displayName = 'Spacer';
Spacer.propTypes = {
  /**
   * Adds CSS padding based on spacing token values
   */
  padding: CustomPropTypes.spacing,
  /**
   * Adds CSS padding-left and padding-right based on spacing token values
   */
  paddingX: CustomPropTypes.spacing,
  /**
   * Adds CSS padding-top and padding-bottom based on spacing token values
   */
  paddingY: CustomPropTypes.spacing,
  /**
   * Adds CSS padding-top based on spacing token values
   */
  paddingTop: CustomPropTypes.spacing,
  /**
   * Adds CSS padding-bottom based on spacing token values
   */
  paddingBottom: CustomPropTypes.spacing,
  /**
   * Adds CSS padding-right based on spacing token values
   */
  paddingRight: CustomPropTypes.spacing,
  /**
   * Adds CSS padding-left based on spacing token values
   */
  paddingLeft: CustomPropTypes.spacing,
  /**
   * Adds CSS margin based on spacing token values
   */
  margin: CustomPropTypes.spacing,
  /**
   * Adds CSS margin-left and margin-right based on spacing token values
   */
  marginX: CustomPropTypes.spacing,
  /**
   * Adds CSS margin-top and margin-bottom based on spacing token values
   */
  marginY: CustomPropTypes.spacing,
  /**
   * Adds CSS margin-top based on spacing token values
   */
  marginTop: CustomPropTypes.spacing,
  /**
   * Adds CSS margin-bottom based on spacing token values
   */
  marginBottom: CustomPropTypes.spacing,
  /**
   * Adds CSS margin-right based on spacing token values
   */
  marginRight: CustomPropTypes.spacing,
  /**
   * Adds CSS margin-left based on spacing token values
   */
  marginLeft: CustomPropTypes.spacing
};

/** @component */
export { Spacer };